module.exports = __webpack_public_path__ + "static/sport/swiper-1.5946cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/swiper-1.png
// module id = BvaE
// module chunks = 0